import {
  Component,
  ElementRef,
  Input,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  DoCheck,
  ViewEncapsulation,
} from '@angular/core';

import { DynamicHTMLRenderer, DynamicHTMLRef } from './renderer';

@Component({
  selector: 'dynamic-html',
  template: '',
  styleUrls: ['./dynamic-html.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DynamicHTMLComponent implements DoCheck, OnChanges, OnDestroy {
  @Input() content: string;
  @Input('ignore-font-size') ignoreFontSize: boolean = false;

  private ref: DynamicHTMLRef = null;

  constructor(
    private renderer: DynamicHTMLRenderer,
    private elementRef: ElementRef,
  ) { }

  ngOnChanges(_: SimpleChanges) {
    //validate if the content is first change to avoid re-rendering
    if (this.ref && (_?.content?.isFirstChange() || _?.content?.previousValue !== _?.content?.currentValue)) {
      this.ref.destroy();
      this.ref = null;
    }

    if (this.content && this.elementRef && (_?.content?.isFirstChange() || _?.content?.previousValue !== _?.content?.currentValue)) {
      this.ref = this.renderer.renderInnerHTML(this.elementRef, this.content);
    }
  }

  ngDoCheck() {
    if (this.ref) {
      this.ref.check();
    }
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.destroy();
      this.ref = null;
    }
  }
}
